import { render, staticRenderFns } from "./dataUpdateInfo.vue?vue&type=template&id=73464580&scoped=true"
import script from "./dataUpdateInfo.vue?vue&type=script&lang=js"
export * from "./dataUpdateInfo.vue?vue&type=script&lang=js"
import style0 from "./dataUpdateInfo.vue?vue&type=style&index=0&id=73464580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73464580",
  null
  
)

export default component.exports